import type { GraphQLTypes, InputType } from '@zeus/index'
import { Selector } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

const rolesSelector = Selector('Role')({
  id: true,
  name: true,
})

export const GQL_ROLES = typedGql('query', { scalars })({
  getRoles: {
    ...rolesSelector,
  },
})

export type StoredRoles = InputType<
  GraphQLTypes['Role'],
  typeof rolesSelector,
typeof scalars
>
